<div class="navigation-wrap">

  <a routerLink="/dashboard" *ngIf="!isCanadaUser && !isDDUser && !isThreeContractNo && !isPirateShip"
    rel="noopener noreferrer">
    <img class="logo" src="../../../../assets/images/logos/ca_us/InsureShield_Logo_226x79_larger_tagline-01.png"
      alt="{{ 'billing.method.altUps' | translate }}">
  </a>
  <a *ngIf="isPirateShip" rel="noopener noreferrer">
    <img class="logo" src=".../../../../assets/images/logos/ca_us/InsureShield_Logo_226x79_larger_tagline-01.png"
      alt="{{ 'billing.method.altUps' | translate }}">
  </a>
  <a routerLink="/dashboard" *ngIf="isThreeContractNo" rel="noopener noreferrer">
    <img class="logo" src="../../../../assets/images/logos/us_eu/Europe_Logo.png"
      alt="{{ 'billing.method.altUps' | translate }}">
  </a>
  <a routerLink="/dashboard" *ngIf="isDDUser" rel="noopener noreferrer">
    <img class="logo" src="../../../../../assets/images/logos/DeliveryDefense_horizontal_USPC.png"
      alt="{{ 'billing.method.altUps' | translate }}">
  </a>
  <a routerLink="/dashboard" *ngIf="isCanadaUser" rel="noopener noreferrer">
    <img class="logo" src="../../../../assets/images/logos/ca_us/UPSC_InsureShield_Horizontal CANADA_226x79_72dpi.png"
      alt="{{ 'billing.method.altUps' | translate }}">
  </a>
  <ul class="navigation-items" [hidden]="!showRLSNav || isPirateShip">
    <li class="navigation-item-short"
      *ngIf="!isAdjuster && !isUspsUser && !isDDUser && !isDDCGUser && (!isGuestClaim) && !isBundledClaim">
      <a href="#" routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"
        (click)="tagging('dashboard')"><span class="new-question">
          <span class="txt">{{'app.navigation.dashboard' | translate }}</span></span>
      </a>
    </li>

    <li class="navigation-item-short"
      *ngIf="!isAdjuster && !isUspsUser && !isDDUser && !isDDCGUser && !isThreeContractNo && (!isGuestClaim) && !isBundledClaim">
      <a href="#" routerLink="/policies" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"
        (click)="tagging('policies')"><span class="new-question">
          <span class="txt">{{
            'app.navigation.policies' | translate }}</span>
        </span>
      </a>
    </li>
    <li class="navigation-item-short"
      *ngIf="((userPermission.isClaimView) || (userPermission.isFileClaim)) && !isAdjuster && !isUspsUser && (!isDDUser || isDDClaimsFlow) && (!isGuestClaim)">
      <span class="h-100">
        <a href="#" routerLink="/claims" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"
          (click)="tagging('claims')">
          <span class="new-question">
            <span class="txt">{{'app.navigation.claims' | translate }}</span>
            <span *ngIf="showStats && (userPermission.isFileClaim)" (click)="gotoMessages($event)" class="message-badge"
              #tooltip="matTooltip" [matTooltip]="messageCnt" [matTooltipPosition]="position.value!"
              [matTooltipHideDelay]="5000">
              {{ claimStats?.claimsWithNewMessagesCnt }}
            </span>
          </span>
        </a>
      </span>
    </li>

    <li class="navigation-item-short"
      *ngIf="((userPermission.isBillingView) && (!isAdjuster) && (!isGuestClaim) && (showBilling)) && !isThreeContractNo && !isDDCGUser">
      <a href="#" routerLink="/billing" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"
        (click)="tagging('billing')">
        <span class="new-question">
          <span class="txt" *ngIf="!(isUsaUser && showBillingWalletTab)">{{ 'app.navigation.billing' | translate
            }}</span>
          <span class="txt" *ngIf="(isUsaUser && showBillingWalletTab)">{{ 'app.navigation.billingWallet' | translate
            }}</span>
        </span>
      </a>
    </li>
    <!-- <li class="navigation-item-short"
      *ngIf="((userPermission.isBillingView) && (!isAdjuster) && (!isGuestClaim) && (showBilling)) && !isThreeContractNo && upsBilled && !isDDCGUser">
      <a (click)="tagging('billing');" routerLink="/billing/mywallet" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
        <span class="new-question">
          <span class="txt" *ngIf="(isUsaUser && showBillingWalletTab)">{{ 'app.navigation.billingWallet' | translate }}</span>
        </span>
      </a>
    </li> -->
    <li class="navigation-item-short" *ngIf="isGuestUser && !isUspsUser && !isDDUser">
      <a href="#" routerLink="/claims/new" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <span class="new-question">
          <span class="txt">{{ 'claims.claimMenus.fileNewClaim' | translate }}</span></span>
      </a>
    </li>
    <li class="navigation-item-short" *ngIf="isGuestUser && !isUspsUser && !isDDUser">
      <a href="#" routerLink="/claims/help" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <span class="new-question">
          <span class="txt">{{ 'claims.claimMenus.claimsHelp' | translate }}</span></span>
      </a>
    </li>

    <!-- <li class="navigation-item-question-mark"
      *ngIf="!isGuestClaim && !isAdjuster && !isUspsUser && hasSmartUpload && (userPermission.isSmartUpload) && !isDDUser && !isDDCGUser && !isBundledClaim">
      <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="startSmartUpload($event)">
        <span class="new-question">
          <span class="txt">{{'smartUpload.title' | translate}}</span>
          <mat-icon class="help-outline-class">help_outline</mat-icon>
        </span>
      </a>
    </li> -->
    <li class="navigation-item-question-mark"
      *ngIf="!isGuestClaim && !isAdjuster && !isUspsUser && hasSmartUpload && (userPermission.isSmartUpload) && !isDDUser && !isDDCGUser && !isBundledClaim && isSmartUploadEnabled">
      <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="navigate2SmartUpload()">
        <span class="new-question">
          <span class="txt">{{'smartUpload.title' | translate}}</span>
          <mat-icon class="help-outline-class">help_outline</mat-icon>
        </span>
      </a>
    </li>

    <li class="navigation-item-question-mark expired-policy-hover"
      *ngIf="!isGuestClaim && !isAdjuster && !isUspsUser && hasSmartUpload && (userPermission.isSmartUpload) && !isDDUser && !isDDCGUser && !isBundledClaim && !isSmartUploadEnabled">
      <a class="disabled-nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"
        aria-disabled="true" tabindex="-1" (click)="$event.preventDefault(); $event.stopPropagation()">
        <span class="new-question">
          <span class="txt">{{'smartUpload.title' | translate}}</span>
          <mat-icon class="help-outline-class">help_outline</mat-icon>
        </span>
      </a>
      <div class="expired-policy-popover">
        Unfortunately, your policy is expired. If you think this is an error, please click <span
          class="expired-policy-link" (click)="redirectToUrl()">here</span>.
      </div>
    </li>
    <li class="navigation-item-question-mark"
      *ngIf="!isGuestClaim && !isAdjuster && !isUspsUser && isUsaUser && !isDDUser && !isDDCGUser && isDDApplicable && !isBundledClaim">
      <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" (click)="validateDeliveryDefense($event)">
        <span class="new-question">
          <span class="txt">{{'app.navigation.deliveryDefense' | translate}}</span>
          <mat-icon class="help-outline-class">help_outline</mat-icon>
        </span>
      </a>
    </li>

    <li class="navigation-item-question-mark" *ngIf="isAdjuster && !isUspsUser && !isBundledClaim">
      <a href="#" routerLink="/adjusterDashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
        <span class="new-question">
          <span class="txt">{{'app.navigation.adjuster.dashboard' | translate}}</span>
          <mat-icon class="help-outline-class">help_outline</mat-icon>
        </span>
      </a>
    </li>
  </ul>

  <!-- SearchTag:NavbarProfilePanel -->
  <div class="nav-welcome-desktop" *ngIf="fName.length>0 && !isPirateShip">
    <mat-list-item>

      <button class="welcome-button round-button" #clickMenuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="!isDDUser ? clickMenu : ''" #tooltip="matTooltip" [matTooltip]="loginName"
        [matTooltipPosition]="position.value!" [matTooltipHideDelay]="5000">
        {{ fName | titlecase }}
      </button>

      <mat-menu overlapTrigger="false" #clickMenu="matMenu">

        <!-- SearchTag:PolicyContainer -->
        <div class="policy-container"
          [ngStyle]="this.policyInfoList.length < 4 ? {'height': 'auto'} : {'max-height': '300px'}">
          <div *ngIf="this.policyInfoList.length > 0 && !isGuestUser && (!isUspsUser) && !isBundledClaim">
            <div *ngFor="let item of policyInfoList" class="policies">

              <!-- SearchTag:ActivePolicyCard -->
              <div *ngIf="item.isActive" class="policy-active">
                <div class="policy-login-info">
                  <button class="welcome-button round-button">
                    {{ fName | titlecase }}
                  </button>

                  <div>

                    <div *ngIf="!isThreeContractNo" class="title"> Policy #{{item.policyNumber}} - {{item.productType}}
                    </div>
                    <div *ngIf="isThreeContractNo" class="title"> Contract #{{item.policyNumber}}</div>

                    <!-- SearchTag:Nickname -->
                    <div class="nickName" *ngIf="!isNickNameEdit && !isInternalUser">
                      <mat-icon (click)="editNickName($event, item.nickName)" [matTooltip]="toolTipInfo | translate"
                        matTooltipPosition="right">
                        edit
                      </mat-icon>
                      {{item.nickName == "" || item.nickName == null ? "" : item.nickName + "&nbsp;"}}
                    </div>

                    <div class="nickName" *ngIf="isNickNameEdit">
                      <form [formGroup]="nickNameFormGroup" class="nickNameForm">
                        <mat-form-field (click)="editNickName($event, item.nickName)">
                          <div class="custom-input">
                            <input matInput [(ngModel)]="item.nickName" (click)="editNickName($event, item.nickName)"
                              formControlName="nickNameFormControl" (keydown.Tab)="updateNickName($event, item)"
                              (keyup.enter)="updateNickName($event, item)">
                          </div>
                          <mat-icon matSuffix (click)="closeNickName($event)">cancel</mat-icon>
                        </mat-form-field>
                      </form>
                    </div>

                    <div *ngIf="!isInternalUser" class="insured">{{item.policyHoldersName}} &nbsp; - &nbsp; <span
                        class="current">Current Viewing</span></div>
                    <div *ngIf="isInternalUser" class="insured">{{item.policyHoldersName}}</div>
                  </div>

                  <div *ngIf="!isInternalUser" class="check-circle"><img
                      src="../../../../../assets/images/check-circle.svg"></div>

                </div>

              </div>

              <!-- SearchTag:InactivePolicyCard -->
              <div class="policy-in-active" *ngIf="!item.isActive" (click)="togglePolicy(item)">
                <div class="policy-login-info">

                  <button class="welcome-button round-button column">
                    {{ fName | titlecase }}
                  </button>

                  <div>
                    <div class="title" *ngIf="!isContract"> Policy #{{item.policyNumber}} - {{item.productType}}</div>
                    <div class="title" *ngIf="isContract"> {{'contract.contractVerbiage' | translate }}
                      #{{policy.policyNumber}}</div>
                    <div class="nickName">{{item.nickName}}</div>
                    <div class="insured">{{item.policyHoldersName}}</div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- SearchTag:LoadingIcon -->
        <div *ngIf="this.policyInfoList.length === 0 && !isGuestUser && !isDDCGUser && !isBundledClaim, else showButton"
          class="loading">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading Policies...</span>
          </div>
        </div>
        <ng-template #showButton>
          <!-- SearchTag:AddPolicyButton -->
          <div class="btnContainer"
            *ngIf="((!isAdjuster) && (!isUspsUser) && (isUsaUser) && (canTogglePolicy)) && !isGuestUser && !isThreeContractNo  && !isBundledClaim">
            <button class="upsc-white-button" (click)="addPolicy()" [disabled]="disableAddPolicy"><mat-icon
                class="icon-key">add</mat-icon>{{'policies.policy.addAnotherPolicy' | translate}}</button>
          </div>
        </ng-template>


        <div class="user-menu-option">
          <button [hidden]="!showRLSMenuItems"
            *ngIf="!isAdjuster && !isUspsUser && !isGuestUser && !isDDCGUser && !isBundledClaim" mat-menu-item
            routerLink='/dashboard' (click)="tagging('dashboard')">{{ 'app.header.accountitems.dashboard' | translate
            }}</button>
          <button [hidden]="!showRLSMenuItems || isThreeContractNo || isContract"
            *ngIf="(!isAdjuster) && (!isUspsUser) && !isGuestUser && !isDDCGUser && !isBundledClaim" mat-menu-item
            routerLink='/profile' (click)="tagging('profile')">{{ 'app.header.accountitems.profile' | translate
            }}</button>
          <button *ngIf="isThreeContractNo && !isBundledClaim" mat-menu-item routerLink='/profile/security'
            (click)="tagging('profile')">{{ 'app.header.accountitems.profile' | translate }} 456</button>

          <button [hidden]="!showRLSMenuItems"
            *ngIf="((!isAdjuster) && (canManageUsers)) && !isGuestUser && !isDDCGUser && !isBundledClaim" mat-menu-item
            routerLink='/manage-users'>{{ 'app.header.accountitems.manage' | translate }}</button>
          <button mat-menu-item (click)="consumerElectedInsurance()" *ngIf="hasCEI && !isDDCGUser">
            {{ 'app.navigation.consumerElectedInsurance' | translate }}
          </button>
          <a [hidden]="!showRLSMenuItems || isThreeContractNo || isContract" mat-menu-item *ngIf="(isUsaUser)"
            href="https://bit.ly/isonlguide" target="_blank" rel="noopener noreferrer">
            {{ 'app.header.accountitems.userguide' | translate }}<mat-icon class="icon-key">launch</mat-icon>
          </a>
          <button [hidden]="!showRLSMenuItems" *ngIf="canChangePolicy" mat-menu-item (click)="resetPolicy()">Change
            Policy</button>
          <button *ngIf="isCCPSelfServicePortal && isAdminUser && (isUsaUser || isCanadaUser)" mat-menu-item
            routerLink='/self-service'>Guest Link Settings</button>
          <a *ngIf="showCRMLink" mat-menu-item href="{{salesforceTicketingSystemSSOURL}}" target="_blank"
            rel="noopener noreferrer">
            {{ 'app.header.accountitems.getSupport' | translate }}<mat-icon class="icon-key"
              [matTooltip]="'app.header.accountitems.getHelp' | translate">help_outline</mat-icon>
          </a>
          <button mat-menu-item (click)="contactUs()" *ngIf="!isGuestUser">
            {{ 'app.navigation.contactUs' | translate }}
          </button>
          <button mat-menu-item (click)="logout($event)" [class.border-top]="showRLSMenuItems">{{
            'app.header.accountitems.logout' | translate }}</button>
        </div>

      </mat-menu>
    </mat-list-item>
  </div>

  <!-- SearchTag: Mobile Policies -->
  <div class="nav-welcome-mobile" *ngIf="!isPirateShip && !isDDCGUser">
    <mat-list-item>
      <button *ngIf="!isGuestUser" class="welcome-button round-button" #clickMenuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="!isDDUser ? clickMenu : ''" #tooltip="matTooltip" [matTooltip]="loginName"
        [matTooltipPosition]="position.value!" [matTooltipHideDelay]="5000">
        {{ fName | titlecase }}
      </button>
      <mat-menu overlapTrigger="false" #clickMenu="matMenu" class="position">
        <div *ngIf="this.policyInfoList.length > 0 && !isGuestUser && (!isUspsUser)  && !isDDCGUser && !isBundledClaim">

          <!-- SearchTag:PolicyContainerMobile -->
          <div *ngFor="let item of policyInfoList" class="policies">
            <div *ngIf="item.isActive" class="policy-active">

              <!-- SearchTag:ActivePolicyCardMobile -->
              <div class="policy-login-info">

                <button class="welcome-button round-button">
                  {{ fName | titlecase }}
                </button>

                <div>
                  <div class="title"> Policy #{{item.policyNumber}} - {{item.productType}}</div>

                  <!-- SearchTag:NicknameMobile -->
                  <div class="nickName" *ngIf="!isNickNameEdit && !isInternalUser">
                    <mat-icon style="font-size: 16px;" (click)="editNickName($event, item.nickName)">edit</mat-icon>
                    {{item.nickName}}
                  </div>
                  <div class="nickName" *ngIf="isNickNameEdit">
                    <form [formGroup]="nickNameFormGroup" class="nickNameForm">
                      <mat-form-field (click)="editNickName($event, item.nickName)">
                        <div class="custom-input">
                          <input matInput [(ngModel)]="item.nickName" (click)="editNickName($event, item.nickName)"
                            formControlName="nickNameFormControl" (keydown.Tab)="updateNickName($event, item)"
                            (keyup.enter)="updateNickName($event, item)">
                        </div>
                        <mat-icon matSuffix (click)="closeNickName($event)">cancel</mat-icon>
                      </mat-form-field>
                    </form>
                  </div>

                  <div *ngIf="!isInternalUser" class="insured">{{item.policyHoldersName}} - <span
                      class="current">Current Viewing</span></div>
                  <div *ngIf="isInternalUser" class="insured">{{item.policyHoldersName}}</div>
                </div>

                <div *ngIf="!isInternalUser" class="check-circle"><img
                    src="../../../../../assets/images/check-circle.svg"></div>

              </div>

            </div>

            <!-- SearchTag:InactivePolicyCardMobile -->
            <div class="policy-in-active" *ngIf="!item.isActive" (click)="togglePolicy(item)">
              <div class="policy-login-info">

                <button class="welcome-button round-button">
                  {{ fName | titlecase }}
                </button>

                <div>
                  <div class="title"> Policy #{{item.policyNumber}} - {{item.productType}}</div>
                  <div class="nickName">{{item.nickName}}</div>
                  <div class="insured">{{item.policyHoldersName}}</div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div *ngIf="this.policyInfoList.length === 0 && !isGuestUser && !isBundledClaim" class="loading">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading Policies...</span>
          </div>
        </div>

        <div class="btnContainer"
          *ngIf="((!isAdjuster) && (!isUspsUser) && (isUsaUser) && (canTogglePolicy)) && !isGuestUser && !isThreeContractNo && !isBundledClaim">
          <button class="upsc-white-button" (click)="addPolicy()" [disabled]="disableAddPolicy">
            <mat-icon class="icon-key">add</mat-icon>
            {{'policies.policy.addAnotherPolicy' | translate}}
          </button>
        </div>
        <button [hidden]="!showRLSMenuItems" *ngIf="!isAdjuster && !isUspsUser && !isGuestUser && !isBundledClaim"
          mat-menu-item routerLink='/dashboard' (click)="tagging('dashboard')">{{ 'app.header.accountitems.dashboard' |
          translate }}</button>
        <button [hidden]="!showRLSMenuItems || isThreeContractNo"
          *ngIf="(!isAdjuster) && (!isUspsUser) && !isGuestUser && !isBundledClaim" mat-menu-item routerLink='/profile'
          (click)="tagging('profile')">{{ 'app.header.accountitems.profile' | translate }}</button>
        <button *ngIf="isThreeContractNo && !isBundledClaim" mat-menu-item routerLink='/profile/security'
          (click)="tagging('profile')">{{ 'app.header.accountitems.profile' | translate }}</button>
        <button [hidden]="!showRLSMenuItems"
          *ngIf="((!isAdjuster) && (canManageUsers)) && !isGuestUser && !isBundledClaim" mat-menu-item
          routerLink='/manage-users'>{{ 'app.header.accountitems.manage' | translate }}</button>
        <a [hidden]="!showRLSMenuItems || isThreeContractNo" mat-menu-item *ngIf="(isUsaUser)"
          href="https://bit.ly/isonlguide" target="_blank" rel="noopener noreferrer">
          {{ 'app.header.accountitems.userguide' | translate }}<mat-icon class="icon-key">launch</mat-icon>
        </a>
        <button (click)="consumerElectedInsurance()" mat-menu-item *ngIf="hasCEI">
          {{ 'app.navigation.consumerElectedInsurance' | translate }}
        </button>
        <button [hidden]="!showRLSMenuItems && !isBundledClaim" *ngIf="canChangePolicy" mat-menu-item
          (click)="resetPolicy()">
          Change Policy
        </button>
        <a *ngIf="showCRMLink" mat-menu-item href="{{salesforceTicketingSystemSSOURL}}" target="_blank"
          rel="noopener noreferrer">
          {{ 'app.header.accountitems.getSupport' | translate }}<mat-icon class="icon-key"
            [matTooltip]="'app.header.accountitems.getHelp' | translate">help_outline</mat-icon>
        </a>
        <button (click)="contactUs()" mat-menu-item *ngIf="!isGuestUser">
          {{ 'app.navigation.contactUs' | translate }}
        </button>
        <button mat-menu-item (click)="logout($event)" [class.border-top]="showRLSMenuItems">
          {{ 'app.header.accountitems.logout' | translate }}
        </button>
      </mat-menu>
    </mat-list-item>
    <button class="contact-button" *ngIf="!isAdjuster && !isDDUser">
      <mat-icon (click)="isCollapsed = !isCollapsed">menu</mat-icon>
    </button>
  </div>

  <div *ngIf="!isCollapsed && (!isUspsUser)" class="sidebar">
    <div class="well well-lg">
      <button [hidden]="!showRLSMenuItems"
        *ngIf="!isAdjuster && !isDDUser && !isDDCGUser && (!isGuestClaim) && !isBundledClaim"
        mat-menu-item routerLink='/dashboard' (click)="tagging('dashboard')">{{ 'app.navigation.dashboard' | translate
        }}</button>

      <button [hidden]="!showRLSMenuItems" [class.border-top]="showRLSMenuItems"
        *ngIf="!isAdjuster && !isDDUser && !isDDCGUser && !isThreeContractNo && (!isGuestClaim) && !isBundledClaim"
        mat-menu-item routerLink='/policies' (click)="tagging('policies')">{{ 'app.navigation.policies' | translate
        }}</button>

      <button [hidden]="!showRLSMenuItems" [class.border-top]="showRLSMenuItems"
        *ngIf="(userPermission.isClaimView) || (userPermission.isFileClaim) && !isAdjuster && !isDDUser && (!isGuestClaim)"
        mat-menu-item routerLink='/claims' (click)="tagging('claims')">{{ 'app.navigation.claims' | translate }}
      </button>

      <button [hidden]="!showRLSMenuItems" [class.border-top]="showRLSMenuItems"
        *ngIf="(userPermission.isBillingView) && !isAdjuster && !isGuestClaim && showBilling && !isThreeContractNo && !isDDCGUser"
        mat-menu-item routerLink='/billing' (click)="tagging('billing')">
        <span *ngIf="!(isUsaUser && showBillingWalletTab)">{{ 'app.navigation.billing' | translate }}</span>
        <span *ngIf="(isUsaUser && showBillingWalletTab)">{{ 'app.navigation.billingWallet' | translate }}</span>
      </button>

      <!-- <button [hidden]="!showRLSMenuItems" [class.border-top]="showRLSMenuItems"
        *ngIf="(userPermission.isBillingView) && !isAdjuster && !isGuestClaim && showBilling && !isThreeContractNo && upsBilled && !isDDCGUser" mat-menu-item
        routerLink='/billing/mywallet' (click)="tagging('billing')">
        <span *ngIf="(isUsaUser && showBillingWalletTab)">{{ 'app.navigation.billingWallet' | translate }}</span>
      </button> -->

      <button [hidden]="!showRLSMenuItems" [class.border-top]="showRLSMenuItems" *ngIf="!isGuestUser && !isDDUser"
        mat-menu-item routerLink='/claims/new' (click)="tagging('claims/new')">{{ 'claims.claimMenus.fileNewClaim' |
        translate
        }}</button>

      <button [hidden]="!showRLSMenuItems" *ngIf="isGuestUser && !isDDUser" mat-menu-item routerLink='/claims/new'
        (click)="tagging('claims/new')">{{ 'claims.claimMenus.fileNewClaim' |
        translate
        }}</button>


      <button [hidden]="!showRLSMenuItems" [class.border-top]="showRLSMenuItems" *ngIf="isGuestUser && !isDDUser"
        mat-menu-item routerLink='/claims/new' (click)="tagging('claims/help')">{{ 'claims.claimMenus.claimsHelp' |
        translate
        }}</button>

     <!--  <button [hidden]="!showRLSMenuItems" [class.border-top]="showRLSMenuItems"
        *ngIf="!isGuestClaim && !isAdjuster && hasSmartUpload && (userPermission.isSmartUpload) && !isDDUser && !isBundledClaim"
        mat-menu-item (click)="startSmartUpload($event)">
        {{ 'smartUpload.title' | translate }}</button> -->

      <button [hidden]="!showRLSMenuItems" [class.border-top]="showRLSMenuItems"
        *ngIf="!isGuestClaim && !isAdjuster && hasSmartUpload && (userPermission.isSmartUpload) && !isDDUser && !isBundledClaim && isSmartUploadEnabled"
        mat-menu-item (click)="navigate2SmartUpload()">
        {{ 'smartUpload.title' | translate }}</button>

      <div [hidden]="!showRLSMenuItems" [class.border-top]="showRLSMenuItems"
        *ngIf="!isGuestClaim && !isAdjuster && hasSmartUpload && (userPermission.isSmartUpload) && !isDDUser && !isBundledClaim && !isSmartUploadEnabled"
        class="expired-policy-hover" [class.expired-policy-popover-open]="isExpiredPolicyPopoverOpen">
        <button class="disabled-nav-item" mat-menu-item aria-disabled="true" tabindex="-1"
          (click)="toggleExpiredPolicyPopover($event)">
          {{ 'smartUpload.title' | translate }}
        </button>
        <div class="expired-policy-popover">
          Unfortunately, your policy is expired. If you think this is an error, please click <span
            class="expired-policy-link" (click)="openExpiredPolicyLink($event)">here</span>.
        </div>
      </div>

      <button [hidden]="!showRLSMenuItems" [class.border-top]="showRLSMenuItems"
        *ngIf="!isGuestClaim && !isAdjuster && !isDDUser && !isDDCGUser && isUsaUser && isDDApplicable && !isBundledClaim"
        mat-menu-item (click)="validateDeliveryDefense($event)">DeliveryDefense</button>
      <button [hidden]="!showRLSMenuItems" [class.border-top]="showRLSMenuItems" *ngIf="isAdjuster && !isBundledClaim"
        mat-menu-item routerLink='/adjusterDashboard' (click)="tagging('adjusterDashboard')">{{
        'app.navigation.adjuster.dashboard'
        |
        translate }}</button>
    </div>
  </div>